<template>
	<main class="page-layout">
		<div v-if="$slots.header" class="page-layout__header">
			<slot name="header" />
		</div>
		<div class="page-layout__content" tabindex="0">
			<slot></slot>
		</div>
		<div v-if="$slots.footer" class="page-layout__footer">
			<slot name="footer" />
		</div>
	</main>
</template>

<style lang="scss" scoped>
.page-layout {
	height: calc(100vh - #{$height-app-header});
	padding: 0 $spacing-8;
	overflow-y: scroll;
	background-color: $color-neutral-50;
	display: flex;
	flex-direction: column;

	&__header {
		position: sticky;
		top: 0;
		padding: $spacing-3 0;
		background-color: $color-neutral-50;
		border-bottom: 1px solid $color-neutral-100;
		z-index: $z-index-2;
	}

	&__content {
		padding: $spacing-4 0;
		flex-grow: 2;
	}

	&__footer {
		position: sticky;
		bottom: calc($height-form-element / 2 + $spacing-2);
		padding: $spacing-2 $spacing-2 $spacing-8 $spacing-2;
		background-color: $color-neutral-50;
	}
}
</style>
